import { api } from "./dataService";

/**
 * Get contract assignments for a user.
 * Returns assignments with scope, selected objects, and all available objects per contract.
 *
 * @param {number} userId
 * @returns {Promise<{user: Object, assignments: Array}>}
 */
export const getContractAssignments = async (userId) => {
  const response = await api.get(`data/users/${userId}/contract-assignments`);
  return response.data;
};

/**
 * Declarative update of contract assignments for a user.
 * The payload represents the complete desired state.
 *
 * @param {number} userId
 * @param {Array<{contract_id: number, assignment_scope: string, selected_object_ids?: number[]}>} assignments
 * @returns {Promise<Object>}
 */
export const updateContractAssignments = async (userId, assignments) => {
  const response = await api.put(`data/users/${userId}/contract-assignments`, {
    assignments,
  });
  return response.data;
};

/**
 * Get contracts available for assignment to this user.
 * Returns contracts belonging to the user's customer that are not yet assigned.
 *
 * @param {number} userId
 * @returns {Promise<Array<{contract_id: number, contract_id_ov: string, contract_number: string, contract_type: string, company_name: string|null}>>}
 */
export const getAvailableContracts = async (userId) => {
  const response = await api.get(`data/users/${userId}/available-contracts`);
  return response.data;
};
